export default theme => ({
  form: {
    padding: 0,
    margin: 0,
    height: 44,
    overflow: 'hidden',
    // background: '#fff',
    paddingRight: 5,
    zIndex: 2,
    borderRight: '1px solid #e0e0e0',
  },
  input: {
    width: 120,
    border: 0,
    verticalAlign: 'top',
    paddingRight: 4,
    fontSize: 12,
    color: '#f00',
    display: 'inline-block',
    height: 36,
    padding: 0,
    outline: 'none',
    margin: '4px 0'
  },
  searchIcon: {
    width: 36,
    cursor: 'pointer',
    background: "url('/caffecinema/img/search-16x16.png') no-repeat center center",
    marginLeft: 2,
    display: 'inline-block',
    height: 36,
    padding: 0,
    margin: '4px 0',
    border: 'none',
    borderRadius: 3,
    outline: 'none',

    '&:hover': {
      backgroundColor: '#eee'
    }
  }
});